import { digits, letters, PlatePattern } from '../PlateInput/PlateInput.model';

type PlateSlot = { kind: 'letter' | 'digit'; value: string };

const isDigit = (char: string) => digits.includes(char);
const isLetter = (char: string) => letters.includes(char.toLowerCase());

const getPlateSlots = (input: string): PlateSlot[] => {
	const slots: PlateSlot[] = [];
	for (let i = 0; i < PlatePattern.length; i++) {
		const patternChar = PlatePattern[i];
		const sourceChar = input[i] ?? ' ';
		if (patternChar === 'd') {
			slots.push({
				kind: 'digit',
				value: isDigit(sourceChar) ? sourceChar : ' ',
			});
		} else {
			slots.push({
				kind: 'letter',
				value: isLetter(sourceChar) ? sourceChar : ' ',
			});
		}
	}
	return slots;
};

export { getPlateSlots };
export type { PlateSlot };
